// Ruta: frontend/src/modules/checklists/pages/ChecklistDetailPage.tsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useChecklist } from '@core/hooks/useChecklist';
import { Button } from '@shared/components/Button';
import { Checklist } from '@core/types';
import QRCode from 'react-qr-code'; // ✅ Nueva librería

const ChecklistDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [checklist, setChecklist] = useState<Checklist | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { getChecklistById } = useChecklist();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) return;
    const load = async () => {
      try {
        const data = await getChecklistById(id);
        setChecklist(data);
      } catch (error) {
        console.error('Error cargando checklist:', error);
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, [id]);

  if (isLoading) {
    return <div className="text-center py-12 text-gray-500">Cargando checklist...</div>;
  }

  if (!checklist) {
    return <div className="text-center py-12 text-gray-500">Checklist no encontrado</div>;
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900">{checklist.title}</h1>
        <div className="space-x-2">
          <Button variant="secondary" onClick={() => navigate('/checklists')}>
            Volver
          </Button>
          <Button onClick={() => navigate(`/checklists/${id}/edit`)}>Editar</Button>
        </div>
      </div>

      {checklist.description && (
        <div className="bg-white rounded-lg shadow p-4">
          <p className="text-gray-700">{checklist.description}</p>
        </div>
      )}

      <div className="bg-white rounded-lg shadow p-4">
        <h2 className="text-lg font-medium text-gray-900 mb-4">Código QR</h2>
        {checklist.qrCode ? (
          <div className="flex flex-col items-center">
            <QRCode value={checklist.qrCode} size={200} />
            <p className="text-xs text-gray-500 mt-2">Escanea este código desde la app</p>
          </div>
        ) : (
          <p className="text-gray-500">No hay código QR generado</p>
        )}
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <h2 className="text-lg font-medium text-gray-900 p-4 border-b">
          Preguntas ({checklist.questions.length})
        </h2>
        <ul className="divide-y divide-gray-200">
          {checklist.questions.map((q, index) => (
            <li key={q.id} className="p-4 hover:bg-gray-50">
              <div className="flex items-start justify-between">
                <div>
                  <span className="text-sm text-gray-500">#{index + 1}</span>
                  <span className="ml-2 font-medium">{q.text}</span>
                  {q.required && <span className="ml-2 text-red-500 text-sm">*</span>}
                </div>
                <span className="text-xs bg-gray-100 px-2 py-1 rounded">{q.type}</span>
              </div>
              {q.options && q.options.length > 0 && (
                <div className="mt-1 text-sm text-gray-500">Opciones: {q.options.join(', ')}</div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ChecklistDetailPage;